
import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { GENERATE_PASSPORT_BACKGROUND_INPUT_TEXT, PROMPT_TEXT_AREA_LABEL_TEXT } from './upload-image-to-s3-ai.texts';
import { FormField } from '../../../../../../../global/form/form-field/form-field';

const PromptInputScreen = mobxReact.observer(props => {
    const { vm } = props;

    return (
        <div className='oe-form_body'>
            <p>
                <FormattedMessage
                    {...GENERATE_PASSPORT_BACKGROUND_INPUT_TEXT}
                    values={{ br: <br /> }}
                />
            </p>
            <FormField
                className='oe-form-field'
                label={
                    <FormattedMessage
                        {...PROMPT_TEXT_AREA_LABEL_TEXT}
                    />
                }
            >
                <textarea
                    className='generate-passport-background-modal__textarea'
                    value={vm.getPrompt()}
                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => vm.setPrompt(e.target.value)}
                />
                <span className='oe-form-field__error'>{vm.getTooLongPromptError()}</span>
            </FormField>
        </div>
    );
});

export { PromptInputScreen };